import { render, staticRenderFns } from "./CulturePhaseSelector.vue?vue&type=template&id=49d44946&scoped=true"
import script from "./CulturePhaseSelector.vue?vue&type=script&lang=js"
export * from "./CulturePhaseSelector.vue?vue&type=script&lang=js"
import style0 from "./CulturePhaseSelector.vue?vue&type=style&index=0&id=49d44946&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d44946",
  null
  
)

export default component.exports